import React from "react";
import {
  Stethoscope,
  Sparkles,
  Hand,
  Coffee,
  UtensilsCrossed,
  Scissors,
  BedDouble,
  ShoppingBag,
  Dumbbell,
  Briefcase,
} from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ICONS = [
  Stethoscope,
  Sparkles,
  Hand,
  Coffee,
  UtensilsCrossed,
  Scissors,
  BedDouble,
  ShoppingBag,
  Dumbbell,
  Briefcase,
];

export default function Industries() {
  const { t } = useLang();
  return (
    <section className="section-y bg-white" data-testid="industries-section">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="overline">{t.industries.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
            {t.industries.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {t.industries.items.map((it, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                className="card-soft card-soft-hover p-6 h-full flex flex-col"
                data-testid={`industry-${i}`}
              >
                <span className="grid place-items-center h-10 w-10 rounded-xl bg-brand-ink text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 text-base font-medium text-brand-ink">{it.name}</h3>
                <p className="mt-2 text-sm text-brand-graphite leading-relaxed">{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
